import React, { useEffect, useState } from 'react';
import { projects } from '../../data/project';

const ProjectsListing = () => {

    const [currentIndex, setCurrentIndex] = useState(0);
    const [visibleSlides, setVisibleSlides] = React.useState(2);
    
  // Update visible slides based on screen width
    useEffect(() => {
        const handleResize = () => {
        setVisibleSlides(window.innerWidth < 1100 ? 1 : 2);
        };
        window.addEventListener('resize', handleResize);
        handleResize(); // Initial call
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const maxIndex = projects.length - visibleSlides;

    const handleNext = () => {
        if (currentIndex < maxIndex) {
        setCurrentIndex(prev => prev + 1);
        } else {
        setCurrentIndex(0); // Reset to start
        }
    };

    const handlePrev = () => {
        if (currentIndex > 0) {
        setCurrentIndex(prev => prev - 1);
        } else {
        setCurrentIndex(maxIndex); // Go to end
        }
    };
    return (
        <section id="projects">
            <div className="container">
            <div className="projects-header reveal">
                <div className="section-label">Featured Developments</div>
                <h2 className="section-title">Luxury Projects<br /><em>Handpicked</em> for You</h2>
            </div>

            <div className="slider-track-wrap">
                <div className="slider-track" id="sliderTrack" style={{ 
              transform: `translateX(-${currentIndex * (100 / visibleSlides)}%)`,
            }}>
                {projects.map((project) => (
                    <div 
                        key={project.id} 
                        className="slide"
                        style={{ flex: `0 0 ${100 / visibleSlides}%` }}
                    >
                        <div className="slide-inner">
                        <img src={project.image} alt={project.title} />
                        <div className="slide-overlay"></div>
                        <div className="slide-info">
                            <span className="slide-tag">{project.tag}</span>
                            <h3 className="slide-name">{project.title}</h3>
                            <p className="slide-location">{project.location}</p>
                        </div>
                        </div>
                    </div>
                    ))}
                {/* <div className="slide">
                    <img src="https://images.unsplash.com/photo-1494526585095-c41746248156?auto=format&fit=crop&w=1400&q=80" alt="Yedi Mavi project concept" />
                    <div className="slide-overlay"></div>
                    <div className="slide-info">
                    <div className="slide-tag">Sea View · Ready</div>
                    <div className="slide-name">Yedi Mavi</div>
                    <div className="slide-location">Zeytinburnu, Istanbul</div>
                    </div>
                </div>

                <div className="slide">
                    <img src="https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&w=1400&q=80" alt="Bomonti luxury apartment concept" />
                    <div className="slide-overlay"></div>
                    <div className="slide-info">
                    <div className="slide-tag">Premium · New Build</div>
                    <div className="slide-name">Sinpaş Queen</div>
                    <div className="slide-location">Bomonti, Istanbul</div>
                    </div>
                </div>

                <div className="slide">
                    <img src="https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=1400&q=80" alt="Luxury living room concept" />
                    <div className="slide-overlay"></div>
                    <div className="slide-info">
                    <div className="slide-tag">Luxury · City Core</div>
                    <div className="slide-name">Nişantaşı Koru</div>
                    <div className="slide-location">Nişantaşı, Istanbul</div>
                    </div>
                </div>

                <div className="slide">
                    <img src="https://images.unsplash.com/photo-1513584684374-8bab748fbf90?auto=format&fit=crop&w=1400&q=80" alt="Kocaeli development concept" />
                    <div className="slide-overlay"></div>
                    <div className="slide-info">
                    <div className="slide-tag">Off-Plan · High Yield</div>
                    <div className="slide-name">Akkurt Residence</div>
                    <div className="slide-location">Başiskele, Kocaeli</div>
                    </div>
                </div>

                <div className="slide">
                    <img src="https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?auto=format&fit=crop&w=1400&q=80" alt="New launch apartment concept"/>
                    <div className="slide-overlay"></div>
                    <div className="slide-info">
                    <div className="slide-tag">New Launch · Family Living</div>
                    <div className="slide-name">Pekdemir Heights</div>
                    <div className="slide-location">Yuvacık, Kocaeli</div>
                    </div>
                </div> */}
                </div>
            </div>

            <div className="slider-controls">
                <button className="slider-btn" id="prevBtn" aria-label="Previous slide" onClick={() => handlePrev()}>←</button>
                <button className="slider-btn" id="nextBtn" aria-label="Next slide" onClick={() => handleNext()}>→</button>
                <div className="slider-counter" id="sliderCounter">{currentIndex + 1} <span>/ {projects.length}</span></div>
            </div>
            </div>
    </section>
    )

}

export default ProjectsListing